// React
import { Fragment } from "react"

// Components
import { styles } from "components"

// Third-Party Libraries
import moment from "moment"
import { Document, Font, Page, Text, View } from "@react-pdf/renderer"

// Types
import { SelectOptionType } from "types"
import { DataType } from "../types"

// Utils
import { convertNumber } from "utils"
import { getSummary } from "../utils"

// Registrasi font
Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4mxP.ttf" // Regular
    },
    {
      src: "https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfBBc9.ttf", // Bold
      fontWeight: "bold"
    }
  ]
})

Font.register({
  family: "FontAwesome",
  src: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.ttf"
})

export function ExportPdf(props: {
	coaData: SelectOptionType[]
	coaFilter: string[]
	companyName?: string
	data: DataType[]
	title: string
}): JSX.Element {
	// Vars
	const { companyName, title } = props

	return (
		<Document>
			<Page size="A4" style={styles.page}>
				<View
          fixed
          style={styles.fixedTop}
        >
					<Text style={styles.title}>{title}</Text>
					{companyName && <Text style={styles.date}>{companyName}</Text>}
					<Text style={styles.date}>Date: {moment().format("DD MMMM YYYY")}</Text>
				</View>

				{props.coaFilter.map((item, key) => {
					// Vars
					const selectedCoa = props.coaData.find(i => i.value === item)?.label ?? "-"
			    const coaList = props.data.filter(i => i.coa_id === item)

					if (coaList.length) {
						return (
							<Fragment key={key}>
								<Text
									style={{
										fontSize: 9,
										marginTop: 10
									}}
								>
									{selectedCoa}
								</Text>

								<TableCell dataList={coaList} />
							</Fragment>
						)
					}

					return <></>
				})}

				<View
          fixed
          style={styles.fixed}
        >
          <Text style={styles.text}>{title} | {companyName ?? "-"} | {moment().format("DD MMM YYYY")}</Text>

          <Text
            style={styles.text}
            render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
          />
        </View>
			</Page>
		</Document>
	)
}


function TableCell(props: {
	dataList: DataType[]
}): JSX.Element {
	// Vars
	const summary = getSummary(props.dataList)
	const header: string[] = [
    "DATE",
    "NUMBER",
    "ACCOUNT",
    "SOURCE",
    "GROUP",
    "CONTACT",
    "DESCRIPTION",
    "REFERENCE",
    "DEBET",
    "CREDIT"
  ]
	const columns: (string | number)[] = [
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		"",
		summary.debit,
		summary.credit
	]

	return (
		<View style={styles.table}>
			{/* Header */}
			<View style={styles.tableHeader}>
				{header.map((col, index) => (
					<View
						key={index}
						style={styles.tableCol}
					>
						<Text
							style={[
								styles.headerText,
								{ fontSize: 9 }
							]}
						>
							{col}
						</Text>
					</View>
				))}
			</View>

			{/* Data */}
			{props.dataList.map((sub, index) => {
				// Vars
				const columns: (string | number)[] = [
					sub.transaction_date,
					sub.coa_code,
					sub.coa_name,
					sub.source,
					sub.group,
					sub.contact,
					sub.description,
					sub.referensi,
					sub.debit,
					sub.credit
				]

				return (
					<View
						key={index}
						style={styles.tableRow}
					>
						{columns.map((item, key) => {
							// Vars
							const isNumber = typeof item === "number"

							return (
								<View
									key={key}
									style={styles.tableCol}
								>
									<Text
										style={[
											styles.tableCell,
											{
												fontSize: 8,
												textAlign: isNumber ? "right" : "left"
											}
										]}
									>
										{isNumber ? convertNumber(item).intoCurrency : item}
									</Text>
								</View>
							)
						})}
					</View>
				)
			})}

			<View style={styles.tableRow}>
				{columns.map((item, key) => {
					// Vars
					const isNumber = typeof item === "number"

					return (
						<View
							key={key}
							style={styles.tableCol}
						>
							<Text
								style={[
									styles.tableCell,
									{
										fontSize: 8,
										textAlign: isNumber ? "right" : "left"
									}
								]}
							>
								{isNumber ? convertNumber(item).intoCurrency : item}
							</Text>
						</View>
					)
				})}
			</View>
		</View>
	)
}